module.exports = __webpack_public_path__ + "static/media/bd5.0e3a1850.jpg";